import styled from 'styled-components';
import { ReactComponent as RiskTestIcon } from '../../assets/img/icons/wykonaj-test.svg';

export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: normal;
  color: #1b1b1b;
`;

export const Icon = styled(RiskTestIcon)`
  height: 44px;
  width: 44px;
`;

export const ListTitle = styled.div`
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 1.71;
  color: #656565;
`;
